import _window from "@/libraries/window";
import Vue from "@/libraries/vue";
import { isMobile } from "@/assets/js/device";
import shareStore from "@/store/share";
export default Vue.extend({
    props: {
        shareData: Object,
        size: String,
    },
    data() {
        const data = {
            isMobile: isMobile(),
        };
        return data;
    },
    computed: {
        navigatorShare() {
            const navigator = _window.navigator;
            return !!navigator && !!navigator.share;
        },
        native() {
            return this.navigatorShare;
        },
        btnSize() {
            const size = this.size || "x-large";
            return { [size]: true };
        },
        url() {
            const shareData = this.shareData;
            const location = _window.location;
            return (shareData && shareData.url) || (location && location.href) || "";
        },
        message() {
            const shareData = this.shareData;
            return (shareData && shareData.message) || "";
        },
        image() {
            const shareData = this.shareData;
            return (shareData && shareData.image) || "";
        },
    },
    methods: {
        share() {
            const url = this.url;
            const message = this.message;
            const image = this.image;
            shareStore.share(message, "", image, url);
        },
        whatsapp() {
            const isMobile = this.isMobile;
            const url = this.url;
            const message = this.message;
            const open = _window.open;
            open &&
                open((isMobile ? "whatsapp://send" : "https://wa.me/") +
                    "?text=" +
                    message +
                    "%20" +
                    url);
        },
        telegram() {
            const url = this.url;
            const message = this.message;
            const open = _window.open;
            open &&
                open("https://telegram.me/share/url?text=" + message + "&amp;url=" + url);
        },
        facebook() {
            const url = this.url;
            const open = _window.open;
            open && open("https://facebook.com/sharer/sharer.php?u=" + url);
        },
        twitter() {
            const url = this.url;
            const message = this.message;
            const open = _window.open;
            open &&
                open("https://twitter.com/intent/tweet/?text=" +
                    message +
                    "&amp;url=" +
                    url);
        },
    },
});
